import type { EventEmitter } from "node:events"
import { logger } from "@src/utils/logger"

// internal reference; starts out undefined
let bus: EventEmitter

export const setEventEmitter = (emitter: EventEmitter) => {
  bus = emitter
}

type EmitTypes =
  | "gift_created"
  | "gift_claimed"
  | "gift_link_copied"
  | "gift_link_viewed"
  | "gift_link_refunded"
  | "deposit_initiated"
  | "deposit_success"
  | "deposit_failed"
  | "otc_deal_initiated"
  | "swap_initiated"
  | "swap_confirmed"
  | "swap_failed"
  | "swap_cancelled"
  | "otc_confirmed"
  | "withdrawal_initiated"
  | "withdrawal_confirmed"
  | "withdrawal_failed"
  | "contact_created"
  | "contact_updated"
  | "contact_deleted"
  | "contact_transfer_clicked"
  | "contact_selected_as_recipient"
  | "contact_search_performed"
  | "contact_modal_opened"
  | "contact_create_from_transfer"
  | "swap_quote_requested"
  | "swap_quote_rejected"
  | "swap_abandoned"

export const emitEvent = (type: EmitTypes, data: unknown) => {
  if (!bus) {
    logger.error("EventEmitter not set!")
    return
  }
  bus.emit(type, data)
}
